import { SITE } from "@/data/site";

export const DEFAULT_WHATSAPP_MESSAGE =
  "Olá! Vim pelo site da RAMALIVE ODONTOLOGIA e gostaria de mais informações.";

export function buildWhatsAppUrl(message = DEFAULT_WHATSAPP_MESSAGE) {
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;
}

export function buildAppointmentWhatsAppMessage(data) {
  const lines = [
    "Olá! Enviei uma solicitação de agendamento pelo site da RAMALIVE ODONTOLOGIA.",
    "",
    `Nome: ${data.name}`,
    `Telefone: ${data.phone}`,
    `Data desejada: ${data.dateLabel}`,
    `Horário desejado: ${data.time}`,
    `Motivo: ${data.reason}`,
  ];
  if (data.notes) lines.push(`Observações: ${data.notes}`);
  lines.push("", "Podemos confirmar um horário?");
  return lines.join("\n");
}

export function formatPhoneBR(value) {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 2) return digits ? `(${digits}` : "";
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
